/* パスワードリセット画面 */
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { jumpUrl } from '../Common';
import { createRoot } from 'react-dom/client';

const PasswordReset: React.FC = () => {
  // パスワードリセットメール情報のState
  // 処理結果通知ダイアログ
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const successDialogMessage = 'パスワードリセットの案内メールを送付しました。';

  // メールアドレス
  const [email, setResetMail] = useState('');
  // 表示メッセージ
  const [send_reset_mail_message, setSendResetMailResult] = useState();
  const [dialog_message, setDialogMessage] = useState('init');

  // HTTPステータスコード
  const [status_code, setStatusCode] = useState(0);

  // Ajax通信中フラグ
  const [is_connecting, setIsConnecting] = useState(false);

  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
  }, []);
  // パスワード変更ボタンのクリックイベントを定義
  const handleClick = () => {
    // パスワードリセットメール情報をStateへセット
    const mail_info = { email: email };
    const sendResetMail = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);

        // 成功
        const response = await axios.post('/applicant/send_mail', mail_info);
        setSendResetMailResult(response.data.message);
        setDialogMessage(successDialogMessage);
        setStatusCode(response.status);
        // ダイアログ表示
        handleShow();
        console.log('成功' + dialog_message);
        setIsConnecting(false);
      } catch (error) {
        // 失敗
        jumpUrl(error.response.data.url);
        setSendResetMailResult(error.response.data.message);
        setStatusCode(error.response.status);
        console.log('失敗' + dialog_message);
        setIsConnecting(false);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    // パスワードリセットメール送信
    sendResetMail();
  };
  // 完了ダイアログでOKをクリックしたらログイン画面へ遷移
  const handleClickOk = () => {
    handleClose();
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
  };
  /**
   * 戻るボタンをクリックする
   */
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
  };
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="パスワードリセット"
        content={
          <>
            <Annotation text="ご登録のメールアドレスにパスワードリセットの案内メールを送付します。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="email"
                label="メールアドレス"
                value={email}
                placeholder="example@example.com"
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setResetMail(event.target.value)
                }
                disabled={false}
                maxlength={200}
              />
            </div>
            <div className="mt-3"></div>
            <Row className="d-flex align-items-center justify-content-center">
              <Col></Col>
              {send_reset_mail_message !== undefined &&
                // パスワードリセットメールの送信失敗
                status_code !== 200 && (
                  // 失敗
                  <Col md={9} className="alert-danger alert-danger-custom">
                    {send_reset_mail_message}
                  </Col>
                )}
            </Row>
          </>
        }
      />
      <CenterButton label="リセットメール送信" handleClick={handleClick} />
      <div className="mt-4 text-center">
        <Button
          variant="main-color"
          className="return-button"
          size="lg"
          onClick={handleClickReturn}
        >
          戻る
        </Button>
      </div>
      {/* モーダル */}
      <Modal
        className="d-flex modal-dialog-centered"
        show={show}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="dialog-title">メール送信結果</Modal.Title>
        </Modal.Header>
        <Modal.Body className="dialog-body">{dialog_message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClickOk}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};

const container = document.getElementById('password-reset-imp');
if (container) {
  const root = createRoot(container);
  root.render(<PasswordReset />);
}
